<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" :md="8" class="wrapperWidthBottom">
        <v-row no-gutters justify="space-between">
          <div class="text-h5 font-weight-bold black--text mb-4">
            <translate>Golf played</translate>
          </div>
        </v-row>
        <div>
          <template v-if="listGolfCourse.length !== 0">
            <CardRanking
              v-for="(item, idx) in listGolfCourse"
              :key="idx"
              :data="item"
              :isFlag="true"
              :idx="idx + 1"
            />
          </template>
          <InfiniteLoad @loading="loadMore" :disabled="endData" />
        </div>
      </v-col>
      <v-col cols="12" :md="4"></v-col>
    </v-row>
  </div>
</template>
<script>
import { mergeByKey } from "@/utils/helper.js";
import InfiniteLoad from "@/components/InfiniteLoad/InfiniteLoad";
import CardRanking from "@/components/Ranking/CardRanking";
import GolfCourseService from "@/services/GolfCourseService";
export default {
  name: "GolfPlayed",
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },
  components: { CardRanking, InfiniteLoad },
  data: () => ({
    courseSelected: null,
    listGolfCourse: [],
    totalPages: null,
    currentPage: 1,
    endData: false,
  }),
  methods: {
    async getListCoursePlayer(page) {
      let result = [];
      let filter_user = this.user.id;
      let listCourse = await GolfCourseService.getCoursePlayer({
        page,
        filter_user,
      });
      if (!listCourse.error)
        result = listCourse.list.map((item) => item.course);
      //set totalPages
      this.totalPages = listCourse.totalPages;

      this.listGolfCourse = mergeByKey(this.listGolfCourse, result, "id");
    },
    async loadMore(page) {
      await this.getListCoursePlayer(page);
      if (page >= this.totalPages) {
        this.endData = true;
        return;
      }
    },
  },
  mounted() {
    window.scrollBy(0, 1);
  },
};
</script>

<style lang="scss">
.wrapperAvatarBox {
  margin-top: -90px;
}
.tableScore {
  width: 100%;
}
.wrapperTable {
  padding: 20px 100px !important;
  tr {
    text-align: center;
  }
  tbody tr:nth-of-type(odd) {
    background-color: #edf6ff;
  }
}
</style>
